import React from 'react';
import { DropdownFormFieldComponent, FieldHeaderComponent, TextFormFieldComponent } from '@vivli/shared/components';
import { IDropdownMenuItem } from '@vivli/shared/infrastructure/interface';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const detailsSectionStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 35% 35%',
    columnGap: '10px',
};

const containerStyle = {
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '20px',
    paddingRight: '40px',
};

const listOptions = [
    { value: 'Academic', label: 'Academic' },
    { value: 'Industry', label: 'Industry' },
    { value: 'Government Organization', label: 'Government Organization' },
    { value: 'Patient Organization', label: 'Patient Organization' },
    { value: 'Non-Profit', label: 'Non-Profit' },
    { value: 'Other', label: 'Other' },
    { value: 'Unassigned', label: 'Unassigned' },
];

const typeItems = listOptions?.map(
    (option) =>
        ({
            title: option.label,
            value: option.value,
        } as IDropdownMenuItem)
);

const organizationCodeHint = 'Organization code must be at least a 3 digit alphanumeric code.';
const organizationUrlHint =
    'Data Contributor ' +
    'organizations working with Vivli Partner Platforms should include the exact URL of the platform ' +
    'that will provide studies or study IPD. Please copy the URL from the browser input window.';

export const OrgDetailsSectionComponent = () => {
    //TODO PERMFE - redo with permissions+
    const isVivliAdmin = useActiveUserContext().hasPermission(PermissionsEnum.CreateOrg);
    return (
        <div style={containerStyle}>
            <FieldHeaderComponent title={'ORGANIZATION DETAILS'} />
            <div style={detailsSectionStyle}>
                <DropdownFormFieldComponent items={typeItems} name={'type'} label={'Type'} readonly={!isVivliAdmin} />
                <TextFormFieldComponent name={'emailDomain'} label={'Domain'} readonly={!isVivliAdmin} />
                <TextFormFieldComponent name={'code'} label={'Code'} readonly={!isVivliAdmin} hint={organizationCodeHint} />
            </div>
            <div>
                <TextFormFieldComponent
                    name={'organizationRegistryUrl'}
                    label={'Organization/Platform URL for Requesting Studies'}
                    hint={organizationUrlHint}
                    readonly={!isVivliAdmin}
                />
            </div>
        </div>
    );
};
